import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import UploadCard from "./components/UploadCard";
import ResultsSection from "./components/ResultsSection";
import ManualDecode from "./components/ManualDecode";
import ImageModal from "./components/ImageModal";

import { ResetWatermarkDecoder } from "../../store/actions/watermarkDecoderActions";

import "./styles.scss";

const WatermarkDecoder = () => {
  const dispatch = useDispatch();

  const results = useSelector((state) => state.watermarkDecoder.results);

  const [modal, setModal] = useState({ open: false, images: [], index: 0 });

  // Reset feature state when leaving the page.
  useEffect(() => {
    return () => {
      dispatch(ResetWatermarkDecoder());
    };
  }, [dispatch]);

  const openModal = (images, index) => setModal({ open: true, images, index });
  const closeModal = () => setModal((prev) => ({ ...prev, open: false }));
  const setModalIndex = (updater) =>
    setModal((prev) => ({
      ...prev,
      index: typeof updater === "function" ? updater(prev.index) : updater,
    }));

  const resetHandler = () => dispatch(ResetWatermarkDecoder());

  return (
    <div className="watermark-decoder">
      <div className="watermark-decoder__header">
        <h1>Watermark Decoder</h1>
        <p>Extract watermark information from a screenshot or camera image. Upload a PNG or JPG file to analyze.</p>
      </div>

      <div className="watermark-decoder__body">
        {results ? (
          <ResultsSection results={results} onOpenModal={openModal} onReset={resetHandler} />
        ) : (
          <UploadCard />
        )}

        <ManualDecode />
      </div>

      {modal.open && (
        <ImageModal
          images={modal.images}
          index={modal.index}
          setIndex={setModalIndex}
          onClose={closeModal}
        />
      )}
    </div>
  );
};

export default WatermarkDecoder;
